<template>
  <div class="app-main-content advance-payment">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" :lazy="true" type="card" style="width:100%;">
        <el-tab-pane v-if="tabQueryBalanceIsShowed" :label="$t('AdvancePayment.QueryBalance')" name="queryBalance">
          <query-balance key="queryBalance" ref="queryBalance" :is-show="queryBalanceIsShow" />
        </el-tab-pane>
        <el-tab-pane v-if="tabQueryDetailIsShowed" :lazy="true" :label="$t('AdvancePayment.QueryDetail')" name="queryDetail">
          <query-detail
            v-show="searchConditions.searchMode===1"
            key="queryDetail"
            ref="queryDetail"
            :is-show="queryDetailIsShow"
          >
            <template v-slot:searchAreaHeader>
              <advance-payment-search-area-header :search-conditions="searchConditions" />
            </template>
          </query-detail>
          <query-finance-balance
            v-show="searchConditions.searchMode===2"
            key="queryFinanceBalance"
            ref="queryFinanceBalance"
            :is-show="queryFinanceBalanceIsShow"
          >
            <template v-slot:searchAreaHeader>
              <advance-payment-search-area-header :search-conditions="searchConditions" />
            </template>
          </query-finance-balance>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import queryBalance from '@/views/cargo/v0/Clearing/components/advancePayment/queryBalance'
import queryDetail from '@/views/cargo/v0/Clearing/components/advancePayment/queryDetail'
import queryFinanceBalance from '@/views/cargo/v0/Clearing/components/advancePayment/queryFinanceBalance'
import advancePaymentSearchAreaHeader from '@/views/cargo/v0/Clearing/components/advancePayment/advancePaymentSearchAreaHeader'

export default {
  name: 'AdvancePayment',
  components: { queryBalance, queryDetail, queryFinanceBalance, advancePaymentSearchAreaHeader },
  data() {
    return {
      activeTabName: 'queryBalance',
      tabQueryBalanceIsShowed: this.$checkPermission(['tab_AdvancePayment_queryBalance']),
      tabQueryDetailIsShowed: this.$checkPermission(['tab_AdvancePayment_queryDetail']),
      queryBalanceIsShowed: false,
      queryDetailIsShowed: false,
      queryFinanceBalanceIsShowed: false,
      searchConditions: {
        searchMode: 1 // 1=余额变动明细、2=业财余额
      }
    }
  },
  computed: {
    queryBalanceIsShow() {
      if (this.activeTabName === 'queryBalance' && !this.queryBalanceIsShowed) {
        this.queryBalanceIsShowed = true
      }
      return this.queryBalanceIsShowed
    },
    queryDetailIsShow() {
      if (this.activeTabName === 'queryDetail' && this.searchConditions.searchMode === 1 && !this.queryDetailIsShowed) {
        this.queryDetailIsShowed = true
      }
      return this.queryDetailIsShowed
    },
    queryFinanceBalanceIsShow() {
      if (this.activeTabName === 'queryDetail' && this.searchConditions.searchMode === 2 && !this.queryFinanceBalanceIsShowed) {
        this.queryFinanceBalanceIsShowed = true
      }
      return this.queryFinanceBalanceIsShowed
    }
  },
  created() {
    this.defaultActiveTabName()
  },
  methods: {
    defaultActiveTabName() {
      if (this.tabQueryBalanceIsShowed) {
        this.activeTabName = 'queryBalance'
      } else if (this.tabQueryDetailIsShowed) {
        this.activeTabName = 'queryDetail'
      }
    }
  }
}
</script>
